<div class="c-discontinuedReward">
  <div class="c-discontinuedReward__background">
    <div class="c-discontinuedReward__title">
      <span>{{ 'home.lobby.modals.discontinued-reward.title' | translate | uppercase }}</span>
    </div>

    <div
      class="c-discontinuedReward__gameIcon"
      [ngStyle]="gameIcon"></div>

    <div class="c-discontinuedReward__subtitles">
      <span>{{ 'home.lobby.modals.discontinued-reward.subtitle' | translate }}</span>
      <span>{{ 'home.lobby.modals.discontinued-reward.subtitle-2' | translate }}</span>
    </div>

    <div class="c-discontinuedReward__reward">
      <span>{{
        discontinuedRewardModalData.reward.credits !== 0
          ? (discontinuedRewardModalData.reward.credits | number: '1.0-0' : ('common.culture' | translate))
          : (discontinuedRewardModalData.reward.gems | number: '1.0-0' : ('common.culture' | translate))
      }}</span>
      <slotcom-icon
        [classes]="[discontinuedRewardModalData.reward.credits !== 0 ? 'c-icon--coin' : 'c-icon--gem']"></slotcom-icon>
    </div>

    <slotcom-button
      class="c-button--pink"
      (click)="redeem()"
      audioType="reward">
      {{ 'home.buttons.accept' | translate | uppercase }}
    </slotcom-button>
  </div>
</div>
